import { hasLength } from '@benzinga/utils';

type ElementPosition = ClientRect | null;

const getFontProperty = (elementStyles: CSSStyleDeclaration) => {
  // Firefox does not support getPropertyValue('font');
  const fontStyle = elementStyles.getPropertyValue('font-style');
  const fontVariant = elementStyles.getPropertyValue('font-variant');
  const fontWeight = elementStyles.getPropertyValue('font-weight');
  const fontSize = elementStyles.getPropertyValue('font-size');
  const lineHeight = elementStyles.getPropertyValue('line-height');
  const fontFamily = elementStyles.getPropertyValue('font-family');

  return `${fontStyle} ${fontVariant} ${fontWeight} ${fontSize}/${lineHeight} ${fontFamily}`;
};

// Given text string and an element with the font-style, compute width in px
export function calculateTextWidth(text: string, element: HTMLElement) {
  const canvas = document.createElement('canvas');
  const context = canvas.getContext('2d');
  const elementStyles = window.getComputedStyle(element);
  const font = getFontProperty(elementStyles);

  if (!context) {
    // set a sane default in case canvas is not supported
    return hasLength(text) ? text.length * 7 : 0;
  }

  context.font = font;
  return Math.ceil(context.measureText(text).width);
}

export function getElementPosition(element: HTMLElement): ElementPosition {
  return element && element.parentElement && element.parentElement.getBoundingClientRect();
}
